// Return these changes to the trading file when the capital gain changes arrive in the
// trading project
import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class OnSaleInvestmentsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('OnSaleInvestmentsError', ...args);
    }
}
export default OnSaleInvestmentsError;
